'use client';

import { NavigationConfig } from '@/config/navigation';
import { SidebarGroup } from './sidebar-group';

interface SidebarNavProps {
  config: NavigationConfig;
  collapsed: boolean;
  onItemClick?: () => void;
}

export function SidebarNav({ config, collapsed, onItemClick }: SidebarNavProps) {
  return (
    <div>
      {config.groups.map((group, index) => (
        <div key={group.id} className={index > 0 ? 'mt-4' : ''}>
          <SidebarGroup group={group} collapsed={collapsed} onItemClick={onItemClick} />
        </div>
      ))}
    </div>
  );
}
